import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core';
import { AbstractControl, ControlContainer, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';

import { appendErrorInfos, ValidationMessage } from '../../../structure/validation-message/validation-message';
import { ValidationMessageComponent } from '../../../structure/validation-message/validation-message.component';

@Component({
  selector: 'pf-checkbox',
  standalone: true,
  imports: [ReactiveFormsModule, ValidationMessageComponent],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
  templateUrl: './checkbox.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class CheckboxComponent implements OnInit {
  @Input() label = '';
  @Input() controlName!: string;
  @Input() required = true;
  @Input() validate = false;
  @Input() validationMessages: ValidationMessage[] = [];

  control!: AbstractControl;

  private readonly formGroupDirective = inject(FormGroupDirective);

  ngOnInit(): void {
    const parentForm = this.formGroupDirective.form;
    this.control = parentForm.get(this.controlName)!;
  }

  hasErrors(): boolean {
    return this.validate && !!this.control.errors;
  }

  getRelevantErrorMessage(): ValidationMessage[] {
    const errors = this.control?.errors;
    if (!errors) return [];
    return this.validationMessages
      .filter(vm => vm.key in this.control.errors)
      .map(vm => appendErrorInfos(vm, errors));
  }
}